<template>
  <a-button
    type="text"
    @click="
      handleShowModal();
      $emit('click');
    "
    :disabled="item.status === 2"
    :class="item.status === 2 ? 'button-group-edit' : ''"
  >
    <template #icon>
      <EditOutlined />
    </template>

    Editar grupo
  </a-button>

  <a-drawer
    :visible="visible"
    :title="`Editar grupo - ${item.name}`"
    width="400px"
    :mask-closable="false"
    centered
    :keyboard="false"
    @close="handleConfirmationClose"
  >
    <typification-edit-warning />
    <a-form ref="formRef" :model="formState" :rules="rules" layout="vertical">
      <a-form-item label="Nombre del grupo" name="name">
        <a-input v-model:value="formState.name" placeholder="Escribir nombre del grupo" />
      </a-form-item>

      <a-form-item name="group_type" label="Tipo de grupo">
        <a-select
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          v-model:value="formState.group_type"
          placeholder="Seleccionar tipo de grupo"
        >
          <a-select-option v-for="groupType in groupTypes" :key="groupType.id">
            {{ groupType.name }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item name="code">
        <template #label>
          <span class="label">
            Código de integración
            <a-tooltip>
              <template v-slot:title>
                Código de identificación para exportaciones o integraciones
              </template>
              <InfoCircleOutlined />
            </a-tooltip>
          </span>
        </template>
        <a-input v-model:value="formState.code" placeholder="Escribir código aquí..." />
      </a-form-item>
    </a-form>

    <typification-group-info />

    <fixed-footer
      confirmText="Editar grupo"
      @onCancel="handleCancel"
      @onConfirm="handleOk"
      cancelText="Cancelar"
    />
  </a-drawer>
</template>

<script>
import { defineComponent, reactive, ref, toRaw, createVNode } from "vue";
import { EditOutlined, InfoCircleOutlined, QuestionCircleOutlined } from "@ant-design/icons-vue";
import TypificationGroupInfo from "@/app/entities/components/sections/TypificationGroupInfo.vue";
import TypificationEditWarning from "@/app/entities/components/sections/TypificationEditWarning.vue";
import FixedFooter from "@/app/shared/components/sections/FixedFooter.vue";
import { Modal } from "ant-design-vue";

export default defineComponent({
  components: {
    EditOutlined,
    InfoCircleOutlined,
    TypificationGroupInfo,
    TypificationEditWarning,
    FixedFooter,
  },
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  setup(props) {
    const formRef = ref();
    const formState = reactive({
      name: props.item.name,
      group_type: props.item.group_type,
      code: props.item.code,
    });
    const rules = {
      name: [{ required: true, message: "Campo requerido" }],
      group_type: [{ required: true, message: "Campo requerido" }],
    };
    return {
      formRef,
      formState,
      rules,
    };
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    groupTypes() {
      return this.$store.getters["getGroupTypes"];
    },
  },
  methods: {
    handleOk() {
      this.formRef.validateFields().then(() => {
        let values = toRaw(this.formState);
        if (this.item.name == values.name) {
          delete values.name;
        }
        this.$emit("change", { ...this.item, ...values });
        this.visible = false;
        this.formRef.resetFields();
      });
    },
    handleShowModal() {
      this.visible = true;
      this.formState.name = this.item.name;
      this.formState.group_type = this.item.group_type;
    },
    handleCancel() {
      this.visible = false;
    },
    handleConfirmationClose() {
      Modal.confirm({
        title: "¿Estás seguro de descartar cambios?",
        content: "Al cerrar no se guardarán los datos previamente ingresados",
        icon: createVNode(QuestionCircleOutlined),
        onOk: () => this.handleCancel(),
        centered: true,
        okText: "Descartar",
        cancelText: "Cancelar",
      });
    },
  },
});
</script>

<style lang="sass" scoped>
.ant-form
  margin-bottom: 30px

.text
  font-weight: 600

  &--small
    color: $gray-7
    font-size: 12px
    margin-left: 20px
    font-weight: normal
.button-group-edit
  opacity: 0.4
</style>
